import React, { FunctionComponent } from 'react'
import Svg, { Circle, Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const CircleArrowIcon: FunctionComponent<CircleArrowIconProps> = ({ size = 24, color }) => {
  const { colors } = useTheme()
  const fillColor = color ?? colors.iconDefault
  return (
    <Svg width={size} height={size} viewBox='0 0 20 20' fill='none'>
      <Circle cx='10' cy='10' r='9.25' stroke={fillColor} stroke-width='1.5' />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.4817 5.18031C10.7503 4.92849 11.1722 4.9421 11.424 5.21071L15.4865 9.54404C15.7269 9.80048 15.7269 10.1995 15.4865 10.456L11.424 14.7893C11.1722 15.0579 10.7503 15.0715 10.4817 14.8197C10.2131 14.5679 10.1995 14.146 10.4513 13.8774L13.4613 10.6667H5.00016C4.63197 10.6667 4.3335 10.3682 4.3335 10C4.3335 9.63181 4.63197 9.33334 5.00016 9.33334H13.4613L10.4513 6.12263C10.1995 5.85402 10.2131 5.43213 10.4817 5.18031Z'
        fill={fillColor}
      />
    </Svg>
  )
}

type CircleArrowIconProps = {
  size?: number
  color?: string
}
